"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.767 16.587c-.44 0-.8-.316-.8-.705 0-.39.36-.706.8-.706.442 0 .8.316.8.706 0 .389-.358.705-.8.705zM18.4 9.883h2.145l1.028 2.118H18.4V9.883zm-5.833 6.704c-.441 0-.8-.316-.8-.705 0-.39.359-.706.8-.706.44 0 .8.316.8.706 0 .389-.36.705-.8.705zm9.449-7.26c-.252-.52-.831-.856-1.471-.856H18.4V7.41C18.4 6.632 17.684 6 16.8 6H9.6C8.716 6 8 6.632 8 7.411v7.06c0 .78.716 1.411 1.6 1.411h.567c0 1.17 1.074 2.118 2.4 2.118 1.325 0 2.4-.948 2.4-2.118h3.401c0 1.17 1.074 2.118 2.4 2.118 1.325 0 2.4-.948 2.4-2.118h.032c.442 0 .8-.316.8-.706v-1.765l-1.984-4.085z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.23 12.672c-.223.001-.297-.135-.164-.303l4.161-5.26c.133-.169.211-.138.174.068l-.613 3.369c-.038.206.114.374.337.373l2.341-.008c.224 0 .296.135.161.301L2.245 16.63c-.134.167-.198.137-.142-.065l.987-3.54c.056-.203-.08-.367-.303-.366l-2.557.013z"
}))), 'Delivery24h', {
  viewBox: '0 0 24 24'
});

exports.default = _default;